import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import GuidesIndex from "@/pages/GuidesIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/guides/")({
  head: () => ({
    meta: [
      { title: "Sports Betting Guide: Odds, Value & Bankroll | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["guides"] }).meta },
      { name: "description", content: "Free betting guides on decimal odds, spotting value, and managing your bankroll with the Kelly Criterion. Learn the fundamentals we use ourselves." },
      { property: "og:title", content: "Sports Betting Guide: Odds, Value & Bankroll | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Free betting guides on decimal odds, spotting value, and managing your bankroll with the Kelly Criterion. Learn the fundamentals we use ourselves." },
      { name: "twitter:title", content: "Sports Betting Guide: Odds, Value & Bankroll | Statlign" },
      { name: "twitter:description", content: "Free betting guides on decimal odds, spotting value, and managing your bankroll with the Kelly Criterion. Learn the fundamentals we use ourselves." },
    ],
  }),
  component: () => (
    <MainLayout>
      <GuidesIndex />
    </MainLayout>
  ),
});
